<template>
    <div class="columns small-12 large-6">
        <div class="flex">
            <c-form-element class="flex-grow">
                <c-datepicker
                    v-model="from"
                    :name="filter.name + '-from'"
                    :placeholder="filter.placeholder + ' van'"
                    :key="filter.name + '-from'">
                </c-datepicker>
            </c-form-element>
            <c-form-element class="margin-l-32 flex-grow">
                <c-datepicker
                    v-model="till"
                    :name="filter.name + '-till'"
                    :placeholder="filter.placeholder + ' tot'"
                    :key="filter.name + '-from'">
                </c-datepicker>
            </c-form-element>
        </div>
    </div>
</template>

<script>
import CFormElement from '@components/form/Element';
import CDatepicker from '@components/form/Datepicker';

export default {
    components: { CFormElement, CDatepicker },
    props: {
        filter: {
            type: Object,
            required: true
        },
        selected: {
            default: false
        }
    },
    data() {
        return {
            from: '',
            till: ''
        }
    },
    watch: {
        selected() {
            if ( this.selected === false ) {
                this.from = '';
                this.till = '';
            } 
        },
        from() {
            this.$nextTick( () => {
                this.change();
            });
        },
        till() {
            this.$nextTick( () => {
                this.change();
            });
        }
    },
    methods: {
        change(event) {
            this.$emit('change', {filter: this.filter, value: [this.from, this.till]});
        }
    }
}
</script>
